export function getThreadThemePath(threadOrSlug) {
  const slug = typeof threadOrSlug === 'object' ? threadOrSlug?.slug : threadOrSlug;
  if (!slug) return null;
  return `/threads/${slug}/theme`;
}
